var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { memo, useEffect } from 'react';
import { routeUrls } from 'root/src/shared/descriptions/routes/routeUrls';
import { trpc } from 'root/src/client/v2/trpc/trpc';
import { TourProvider, useTour } from '@reactour/tour';
import { Close } from '@material-ui/icons';
import Confetti from 'react-confetti';
import { OnboardingStateType, CommunityReviewerOnboardingStep, } from 'root/src/shared/onboarding/onboarding.types';
export const PendingReviewsOverlay = memo(({ children }) => {
    var _a;
    const pendingReviewCount = trpc.communityReview.getPendingReviewsCount.useQuery(undefined, {
        refetchInterval: 10 * 1000,
    });
    const reviewCount = (_a = pendingReviewCount === null || pendingReviewCount === void 0 ? void 0 : pendingReviewCount.data) !== null && _a !== void 0 ? _a : 0;
    return (<TourProvider styles={{
            popover: props => (Object.assign(Object.assign({}, props), { borderRadius: '0.5rem' })),
            maskArea: props => (Object.assign(Object.assign({}, props), { fill: 'none' })),
            maskRect: props => (Object.assign(Object.assign({}, props), { fill: 'none' })),
            maskWrapper: props => (Object.assign(Object.assign({}, props), { fill: 'none' })),
            clickArea: props => (Object.assign(Object.assign({}, props), { fill: 'none' })),
        }} showCloseButton={false} showBadge={false} showNavigation={false} steps={[]}>
			<PendingReviewsOnboardingTrigger />
			<div className="relative flex flex-initial items-center">
				{Boolean(reviewCount) && (<div className="absolute right-4 min-[960px]:-right-3 min-[960px]:-top-4 shadow drop-shadow px-1.5 h-4 text-xs uppercase flex flex-initial justify-center font-bold items-center bg-pink text-dark-4 rounded-full">
						{reviewCount}
					</div>)}
				{children}
			</div>
		</TourProvider>);
});
const PendingReviewsOnboardingTrigger = memo(() => {
    const tour = useTour();
    const queryUtils = trpc.useUtils();
    const completeOnboardingState = trpc.onboarding.completeStep.useMutation();
    const handleOnMount = () => __awaiter(void 0, void 0, void 0, function* () {
        const onboardingState = yield queryUtils.onboarding.getState.fetch({
            type: OnboardingStateType.CommunityReviewer,
        });
        if (onboardingState === null || onboardingState === void 0 ? void 0 : onboardingState.hasCheckedClipReview) {
            return;
        }
        void completeOnboardingState.mutateAsync({
            step: CommunityReviewerOnboardingStep.HasCheckedClipReview,
            type: OnboardingStateType.CommunityReviewer,
        });
        tour.setSteps([
            {
                selector: `a[href="${routeUrls.reviewClips()}"] > div`,
                content: () => (<div className="flex flex-col gap-4">
						<button title="Close" className="absolute -top-2 -right-2 shadow size-8 rounded-full bg-white z-10" type="button" onClick={handleClose}>
							<Close className="*:fill-black"/>
						</button>
						<p className="text-black text-sm">
							You made the{' '}
							<span className="font-bold text-black">Top 100</span> in the
							Drop Rankings!{' '}
							<span className="font-bold text-primary">Congratulations!</span>
						</p>
						<p className="text-black text-sm">
							Since you clearly know your way around Dare Drop, we’ve given
							you access to review clips other creators have submitted too!
						</p>
						<p className="text-black text-sm">
							Feel free to{' '}
							<span className="font-bold text-primary">
								stream your reviews
							</span>
							, and no pressure - these are all reviewed by more people and
							double-checked by our team and platform.
						</p>
						<div className="absolute left-0 top-0 w-full h-full overflow-hidden z-0">
							<Confetti recycle={false}/>
						</div>
					</div>),
            },
        ]);
        tour.setIsOpen(true);
    });
    const handleClose = (event) => {
        tour.setIsOpen(false);
        event.stopPropagation();
        event.preventDefault();
    };
    useEffect(() => {
        void handleOnMount();
    }, []);
    return null;
});
